import { Routes, Route } from 'react-router'
import { APP_ROUTES } from './routes'
import HeadSync from './components/HeadSync'

function App() {
  return (
    <>
      <HeadSync />
      <Routes>
        {APP_ROUTES.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Routes>
    </>
  )
}

export default App
